// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__VUwmr","title":"FrontImage_title__1l0AV"};